import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',     to: '/' },
  { label: 'About',    to: '/about' },
  { label: 'Projects', to: '/projects' },
  { label: 'Articles', to: '/articles' },
  { label: 'Contact',  to: '/contact' },
];

export function SiteNav() {
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[var(--color-bg)]/80 border-b border-white/[0.06]">
      <nav
        aria-label="Main navigation"
        className="max-w-5xl mx-auto px-4 sm:px-6 flex items-center justify-between h-14"
      >
        <Link
          to="/"
          className="font-serif text-[var(--color-text)] text-lg tracking-tight hover:text-[var(--color-accent)] transition-colors"
          aria-label="Simone Carani — home"
        >
          SC
        </Link>

        <ul className="flex items-center gap-1">
          {NAV_LINKS.filter((l) => l.to !== '/').map(({ label, to }) => {
            const active = pathname === to || (to !== '/' && pathname.startsWith(to));
            return (
              <li key={to}>
                <Link
                  to={to}
                  aria-current={active ? 'page' : undefined}
                  className={[
                    'px-3 py-1.5 rounded-lg text-sm transition-colors',
                    active
                      ? 'text-[var(--color-text)] bg-white/[0.06]'
                      : 'text-[var(--color-muted)] hover:text-[var(--color-text)] hover:bg-white/[0.04]',
                  ].join(' ')}
                >
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </header>
  );
}
